import api from 'api'

export type AuthorizeAdminRequest = {
  userId: number
}

export type AuthorizeAdminResponse = {
  privilegeId: number
  existing: boolean
}

export async function authorizeAdmin(
  request: AuthorizeAdminRequest
): Promise<AuthorizeAdminResponse> {
  const result = await api.post<AuthorizeAdminResponse>(
    '/admin/permissions/authorize_admin',
    {
      userId: request.userId,
      email: null,
    }
  )
  return result.data
}
